//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"ChangeApproachRetract",1,0],[0,"ChangeProbeAngles",1,0],[0,"ChangeProbeTip",1,0],[0,"ClearanceDistance",1,0],[0,"DeleteMeasurementPoints",1,0],[0,"DeleteUserSafePoints",1,0],[0,"FacetTolerance",1,0],[0,"FinishAtSafePlane",1,0],[0,"ListOutput",1,0],[0,"MaxAngularIncrement",1,0],[0,"MaxLengthIncrement",1,0],[0,"MoveMeasurementPoints",1,0],[0,"NewSensors",1,0],[0,"ProbeRotationsAtSafePlane",1,0],[0,"SafePlane",1,"NXObject",0],[0,"StartFromSafePlane",1,0],[0,"TableRotationsAtSafePlane",1,0],[0,"ToolChangesAtSafePlane",1,0],[0,"TransitionsBetweenPaths",1,0],[0,"TransitionsWithinPaths",1,0]],[[[],"DoCollisionAvoidance",{},0,0],[["nOps"],"GetSelectedOps",{R_:{selectedOps:""}},0,0],[["selectedOps"],"SetSelectedOps",{},1,0],[[],"UpdateSimDisplayOptions",{},0,0]],[]];
SPLM.CAM.InspectionCollisionAvoidanceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionCollisionAvoidanceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;